module.exports = __webpack_public_path__ + "img/consult_info6.0c0adf98.png";